export default __webpack_public_path__ + "static/media/filterfailure.a0e0ed92.jpg";